import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Modal } from 'react-bootstrap';
import NewsShowContext from '../../../context/news_show_context';
import { copyToClipboardFromInputId } from '../../../../utilities/utilities';
import { getSharingToken } from '../../services/sharing_tokens.api.service';
import './share_link_modal.scss';

const ShareLinkModal = ({ closeShareLinkModal, isShareLinkModalOpen }) => {
  const { articleId } = useContext(NewsShowContext);
  const [articleToken, setArticleToken] = useState('');
  const [linkCopied, setLinkCopied] = useState(false);
  const [showTokenError, setShowTokenError] = useState(false);

  useEffect(() => {
    if (isShareLinkModalOpen) {
      getSharingToken(articleId)
        .then((response) => {
          setArticleToken(response.token);
        })
        .catch(() => {
          setShowTokenError(true);
        });
    }
  }, [isShareLinkModalOpen]);

  const hideModal = () => {
    setLinkCopied(false);
    setShowTokenError(false);
    closeShareLinkModal();
  };

  const handleCopyUrl = async () => {
    const result = await copyToClipboardFromInputId('shareableLink');
    setLinkCopied(result);
  };

  return (
    <Modal data-testid='share-link-modal' show={isShareLinkModalOpen} onHide={hideModal}>
      <Modal.Header closeButton className='mb-3'>
        <h2 className='modal-title fs-3'>Get shareable link</h2>
      </Modal.Header>
      <Modal.Body>
        <p className='text-gray-li'>
          Share this article with your team by copying the link below. They will be able to view it
          even if they don‘t have a Devex membership.
        </p>
        <div
          className={classNames('shareable-link px-2', {
            'pt-1 pb-1': !showTokenError,
            'error-message pt-2 pb-2': showTokenError,
          })}
        >
          {showTokenError ? (
            <p data-testid='error-message' className='mb-0'>
              <i className='fal icon-times-circle me-2'></i>
              Error generating shareable link.
            </p>
          ) : (
            <>
              <i className='fal icon-link'></i>
              <input
                readOnly
                type='text'
                className='form-control'
                value={`${window.location.origin}/shared/${articleToken}`}
                id='shareableLink'
              ></input>
            </>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className='mt-3'>
        <button
          className='btn btn-outline-primary'
          onClick={handleCopyUrl}
          disabled={showTokenError}
        >
          {linkCopied ? (
            <span>
              <i className='fal icon-check me-1'></i>Link copied
            </span>
          ) : (
            <span>
              <i className='fal icon-copy me-1'></i>Copy link
            </span>
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

ShareLinkModal.propTypes = {
  isShareLinkModalOpen: PropTypes.bool.isRequired,
  closeShareLinkModal: PropTypes.func.isRequired,
};

export default ShareLinkModal;
